export default __webpack_public_path__ + "static/media/005.01bfc633.jpg";